module.exports = __webpack_public_path__ + "img/indisch_monument_plateau_600x600px.008fbe54.png";